import React, { useEffect, useRef, useState } from 'react';
import NewHeader from './components/NewHeader';
import { Paper, Button } from '@mui/material'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './assests/css/style.css';
import imgurl from './assests/images/imgurl';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardActions';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useNavigate } from "react-router-dom";
import BotComponent from './BotComponent';
import AlertComp from './Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux'
import { setcompounderbeeninformed, setcurrentlyonanymedications, sethairgrowthproductsinthepast, setidentasmale, setknownallergies, setknowncontraindications, setknownmedicalconditions, setpriorreactionstomedications, setpriortreatmentsforhairloss } from './Reducers/reducer'

function Questionnaire() {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    let sliderRef = useRef(null);

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current) => setActiveIndex(current),
    };

    const [activeIndex, setActiveIndex] = useState(0);
    const [items, setitems] = useState(4)
    const [alertopen, setalertopen] = useState(false)
    const [alertmsg, setalertmsg] = useState('Test')

    const [knownmedicalconditions, SETknownmedicalconditions] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [currentlyonanymedications, SETcurrentlyonanymedications] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [knownallergies, SETknownallergies] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [priorreactionstomedications, SETpriorreactionstomedications] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [priortreatmentsforhairloss, SETpriortreatmentsforhairloss] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [hairgrowthproductsinthepast, SEThairgrowthproductsinthepast] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [knowncontraindications, SETknowncontraindications] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })
    const [compounderbeeninformed, SETcompounderbeeninformed] = useState({
        "Answer": "Yes",
        "Please specify (if yes)": ""
    })

    const profile = useSelector((state) => state.user.profile)

    useEffect(() => {
        if(activeIndex==items-1){
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://alopexia.duredemos.com/api/user/register',
                headers: { 
                  'Content-Type': 'application/json'
                },
                data : JSON.stringify(profile)
              };
               
              axios.request(config)
              .then((response) => {
                navigate('/taketest')
                localStorage.setItem('user_id',response.data['userid'])
                console.log(JSON.stringify(response.data));
              })
              .catch((error) => {
                console.log(error);
              });
        }
        console.log('New value', profile) 
      }, [profile])

    function handleCheck(e, state) {
        console.log(e.target.value, state);
        if (state == 'knownmedicalconditions') {
            SETknownmedicalconditions({
                ...knownmedicalconditions,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : knownmedicalconditions['Please specify (if yes)']
            })
        } else if (state == 'currentlyonanymedications') {
            SETcurrentlyonanymedications({
                ...currentlyonanymedications,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : currentlyonanymedications['Please specify (if yes)']

            })
        } else if (state == 'knownallergies') {
            SETknownallergies({
                ...knownallergies,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : knownallergies['Please specify (if yes)']

            })
        } else if (state == 'priorreactionstomedications') {
            SETpriorreactionstomedications({
                ...priorreactionstomedications,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : priorreactionstomedications['Please specify (if yes)']

            })
        } else if (state == 'priortreatmentsforhairloss') {
            SETpriortreatmentsforhairloss({
                ...priortreatmentsforhairloss,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : priortreatmentsforhairloss['Please specify (if yes)']

            })
        } else if (state == 'hairgrowthproductsinthepast') {
            SEThairgrowthproductsinthepast({
                ...hairgrowthproductsinthepast,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : hairgrowthproductsinthepast['Please specify (if yes)']

            })
        } else if (state == 'knowncontraindications') {
            SETknowncontraindications({
                ...knowncontraindications,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : knowncontraindications['Please specify (if yes)']

            })
        } else {
            SETcompounderbeeninformed({
                ...compounderbeeninformed,
                Answer: e.target.value,
                'Please specify (if yes)': e.target.value == 'No' ? '' : compounderbeeninformed['Please specify (if yes)']

            })
        }
    }

    function handleChange(e, state) {
        console.log(e.target.value, state);
        if (state == 'knownmedicalconditions') {
            SETknownmedicalconditions({
                ...knownmedicalconditions,
                "Please specify (if yes)": e.target.value
            })
        } else if (state == 'currentlyonanymedications') {
            SETcurrentlyonanymedications({
                ...currentlyonanymedications,
                "Please specify (if yes)": e.target.value
            })
        } else if (state == 'knownallergies') {
            SETknownallergies({
                ...knownallergies,
                "Please specify (if yes)": e.target.value
            })
        } else if (state == 'priorreactionstomedications') {
            SETpriorreactionstomedications({
                ...priorreactionstomedications,
                "Please specify (if yes)": e.target.value
            })
        } else if (state == 'priortreatmentsforhairloss') {
            SETpriortreatmentsforhairloss({
                ...priortreatmentsforhairloss,
                "Please specify (if yes)": e.target.value
            })
        } else if (state == 'hairgrowthproductsinthepast') {
            SEThairgrowthproductsinthepast({
                ...hairgrowthproductsinthepast,
                "Please specify (if yes)": e.target.value
            })
        } else if (state == 'knowncontraindications') {
            SETknowncontraindications({
                ...knowncontraindications,
                "Please specify (if yes)": e.target.value
            })
        } else {
            SETcompounderbeeninformed({
                ...compounderbeeninformed,
                "Please specify (if yes)": e.target.value
            })
        }
    }

    const goNext = () => {
        console.log(activeIndex);

        if (activeIndex == 0 && (knownmedicalconditions.Answer == 'No' || (knownmedicalconditions.Answer == 'Yes' && knownmedicalconditions['Please specify (if yes)'] != '')) && (currentlyonanymedications.Answer == 'No' || (currentlyonanymedications.Answer == 'Yes' && currentlyonanymedications['Please specify (if yes)'] != ''))) {
            sliderRef.current.slickNext();
            console.log(knownmedicalconditions,currentlyonanymedications);
            
            dispatch(setknownmedicalconditions(knownmedicalconditions))
            dispatch(setcurrentlyonanymedications(currentlyonanymedications))
        } else if (activeIndex == 1 && (knownallergies.Answer == 'No' || (knownallergies.Answer == 'Yes' && knownallergies['Please specify (if yes)'] != '')) && (priorreactionstomedications.Answer == 'No' || (priorreactionstomedications.Answer == 'Yes' && priorreactionstomedications['Please specify (if yes)'] != ''))) {
            sliderRef.current.slickNext();
            console.log(knownallergies,priorreactionstomedications);
            
            dispatch(setknownallergies(knownallergies))
            dispatch( setpriorreactionstomedications(priorreactionstomedications))
        } else if (activeIndex == 2 && (priortreatmentsforhairloss.Answer == 'No' || (priortreatmentsforhairloss.Answer == 'Yes' && priortreatmentsforhairloss['Please specify (if yes)'] != '')) && (hairgrowthproductsinthepast.Answer == 'No' || (hairgrowthproductsinthepast.Answer == 'Yes' && hairgrowthproductsinthepast['Please specify (if yes)'] != ''))) {
            sliderRef.current.slickNext();
            console.log(priortreatmentsforhairloss,hairgrowthproductsinthepast);
            
            dispatch(setpriortreatmentsforhairloss(priortreatmentsforhairloss))
            dispatch( sethairgrowthproductsinthepast(hairgrowthproductsinthepast))
        } else if (activeIndex == items - 1 && (knowncontraindications.Answer == 'No' || (knowncontraindications.Answer == 'Yes' && knowncontraindications['Please specify (if yes)'] != '')) && (compounderbeeninformed.Answer == 'No' || (compounderbeeninformed.Answer == 'Yes' && compounderbeeninformed['Please specify (if yes)'] != ''))) {
            // navigate('/imgupload')
            console.log(knowncontraindications,compounderbeeninformed);
            
            dispatch(setknowncontraindications(knowncontraindications))
            dispatch( setcompounderbeeninformed(compounderbeeninformed))
        } else {
            setalertmsg('Please enter answer all questions.')
            setalertopen(true)
            setTimeout(() => {
                setalertopen(false)
            }, 3000);
        }

    };

    const goPrev = () => {
        console.log(activeIndex);
        
        sliderRef.current.slickPrev();
        if (activeIndex == 0)
            navigate('/profilepage')

    };


    return (
        <div className="questionnaire">
            <NewHeader />
            <div className="blue-shape2 carouselshape">
                <img src={imgurl.shape2} alt="Decorative Shape2" className="decorative-shapetwo" />
            </div>
            {/* <Carousel className="carouselcontainer" cycleNavigation={false} index={activeIndex} 
        navButtonsAlwaysInvisible autoPlay={false}> */}

            <Slider className="carouselcontainer" ref={sliderRef} {...settings}>

                <div key={1}>
                    {/* <Grid container justifyContent="center" alignItems="center" className="hairtypecardsec grid-container">
                        <Grid item xs={12} sm={8} md={6} className="grid-item">
                            <Card className="white-card">
                                <CardContent className="questionnairecard">
                                    <div className="cardcontent">
                                        <div className="cardquestiontext"><p>What is the current length of your hair?</p></div>
                                        <Grid container spacing={2} justifyContent="center" alignItems="center" className='maincardgrid'>
                                            <Grid item xs={6} md={3}>
                                                <div className='cardhairimg'>
                                                    <img src={imgurl.thinhair} alt="Thin Hair" />
                                                </div>
                                                <Card className="thinhaircard">

                                                    <CardContent className='card1'>
                                                        <p>Thin</p>


                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <div className='cardhairimg'>
                                                    <img src={imgurl.shorthair} alt="Short Hair" />
                                                </div>
                                                <Card className="shorthaircard">
                                                    <CardContent className='card1'>
                                                        <p>Short</p>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <div className='cardhairimg'>
                                                    <img src={imgurl.mediumhair} alt="Medium Hair" />
                                                </div>
                                                <Card className="mediumhaircard">
                                                    <CardContent className='card1'>
                                                        <p>Medium</p>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                            <Grid item xs={6} md={3}>
                                                <div className='cardhairimg'>
                                                    <img src={imgurl.longhair} alt="Long Hair" />
                                                </div>
                                                <Card className="longhaircard">
                                                    <CardContent className='card1'>
                                                        <p>Long</p>

                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        </Grid>

                                        <div className='whydoweask'>
                                            <InfoOutlinedIcon />
                                            <p>Why do we ask?</p>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid> */}

                    <Card className='subCardSection'>
                        <CardContent className="questionnairecard">
                            <Grid xs={12} className='slide3gridone'>

                                <Grid xs={4}>
                                    <h2 className='question1 slide3'>{"Do you have any known medical conditions?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "knownmedicalconditions")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>

                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes,please specify:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={knownmedicalconditions['Please specify (if yes)']}
                                        disabled={knownmedicalconditions['Answer'] != "Yes"}
                                        placeholder='If yes,please specify:'
                                        onChange={(e) => handleChange(e, "knownmedicalconditions")}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>

                            <Grid xs={12} className='slide3gridtwo'>

                                <Grid xs={4}>
                                    <hr class="divider" />
                                    <h2 className='question1 slide3'>{"Are you currently on any medications?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "currentlyonanymedications")}

                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>
                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes, list all medications:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={currentlyonanymedications['Please specify (if yes)']}
                                        disabled={currentlyonanymedications['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "currentlyonanymedications")}
                                        placeholder='If yes, list all medications:' variant="outlined" />
                                </Grid>
                                <p className='ensuretext'>(Ensure this includes any over-the-counter or prescribed medications.)</p>

                            </Grid>


                            {/* <p>{props.item.description}</p> */}
                            {/* <Button className="CheckButton">
                    Check it out!
                </Button> */}
                        </CardContent>
                    </Card>

                </div>
                {/* <div key={2}>

                    <Card className='subCardSection'>
                        <CardContent className="questionnairecard">
                            <div className="carousel-top-section">
                                <img src={imgurl.questionnairebg1} alt="Main Image" className="main-image" />
                            </div>
                            <h2 className='question1'>{"Which of these illustrations best matches how visible your scalp is through your hair?"}</h2>

                            <Grid container spacing={2} className="options-grid">
                                First Row: 3 images
                                <Grid item xs={4} className="hairgrid">
                                    <Card className="hairoption1 hairoptionSection">

                                        <div className="pattern1 patternSection">
                                            <img src={imgurl.hairpattern1} alt="Option 1" className="option-image" />
                                        </div>

                                    </Card>

                                </Grid>
                                <Grid item xs={4} className="hairgrid">
                                    <Card className="hairoption2 hairoptionSection">
                                        <div className="pattern2 patternSection">
                                            <img src={imgurl.hairpattern2} alt="Option 2" className="option-image" />
                                        </div>
                                    </Card>
                                </Grid>
                                <Grid item xs={4} className="hairgrid">
                                    <Card className="hairoption3 hairoptionSection">
                                        <div className="pattern3 patternSection">
                                            <img src={imgurl.hairpattern3} alt="Option 3" className="option-image" />
                                        </div>
                                    </Card>
                                </Grid>

                                Second Row: 2 images
                                <Grid item xs={6} className="hairgrid">
                                    <Card className="hairoption4 hairoptionSection">
                                        <div className="pattern4 patternSection">
                                            <img src={imgurl.hairpattern4} alt="Option 4" className="option-image" />
                                        </div>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} className="hairgrid">
                                    <Card className="hairoption5 hairoptionSection">
                                        <div className="pattern5 patternSection">
                                            <img src={imgurl.hairpattern5} alt="Option 5" className="option-image" />
                                        </div>
                                    </Card>
                                </Grid>
                            </Grid>





                            <p>{props.item.description}</p>
                            <Button className="CheckButton">
                Check it out!
            </Button>
                        </CardContent>
                    </Card>
                </div> */}
                <div key={2}>
                    {/* <Card className='subCardSection'>
                        <CardContent className="questionnairecard">
                            <div className="carousel-top-section">
                                <img src={imgurl.questionnairebg2} alt="Main Image" className="main-image" />
                            </div>
                            <h2 className='question1'>{"How much hair are you shedding currently?"}</h2>

                            <Grid container spacing={2} justifyContent="center" alignItems="center" className='maincardgrid hairsheddingsec'>
                                <Grid item xs={6} md={3}>
                                    <Card className="thinhaircard questseccard1">

                                        <CardContent className='card1 hairqs'>
                                            <p>None</p>


                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} md={3}>

                                    <Card className="shorthaircard questseccard2">
                                        <CardContent className='card1 hairqs'>
                                            <p>Quite a lot</p>

                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} md={3} className='slide2card'>

                                    <Card className="mediumhaircard questseccard3">
                                        <CardContent className='card1 hairqs'>
                                            <p>A little bit</p>

                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6} md={3} className='slide2card'>

                                    <Card className="longhaircard questseccard4">
                                        <CardContent className='card1 hairqs'>
                                            <p>Extreme amounts</p>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <div className='whydoweask'>
                                <InfoOutlinedIcon />
                                <p>Why do we ask?</p>
                            </div>




                            <p>{props.item.description}</p>
                            <Button className="CheckButton">
                    Check it out!
                </Button>
                        </CardContent>
                    </Card> */}

                    <Card className='subCardSection'>
                        <CardContent className="questionnairecard">
                            <Grid xs={12} className='slide3gridone'>

                                <Grid xs={4}>
                                    <h2 className='question1 slide3'>{"Do you have any known allergies?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "knownallergies")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>

                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes, list the allergies:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={knownallergies['Please specify (if yes)']}
                                        disabled={knownallergies['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "knownallergies")}
                                        placeholder='If yes, list the allergies:'
                                        variant="outlined"
                                    />
                                </Grid>
                                <p className='ensuretext'>(Include allergies to medications, foods, or environmental factors.)</p>

                            </Grid>

                            <Grid xs={12} className='slide3gridtwo'>

                                <Grid xs={4}>
                                    <hr class="divider" />
                                    <h2 className='question1 slide3'>{"Have you had any prior reactions to medications or treatments?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "priorreactionstomedications")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>
                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes, please describe the reaction:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={priorreactionstomedications['Please specify (if yes)']}
                                        disabled={priorreactionstomedications['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "priorreactionstomedications")}
                                        placeholder='If yes, please describe the reaction:' variant="outlined" />
                                </Grid>
                                <p className='ensuretext'>(Ensure this includes any over-the-counter or prescribed medications.)</p>

                            </Grid>


                            {/* <p>{props.item.description}</p> */}
                            {/* <Button className="CheckButton">
                    Check it out!
                </Button> */}
                        </CardContent>
                    </Card>

                </div>

                <div key={3}>

                    <Card className='subCardSection'>
                        <CardContent className="questionnairecard">
                            <Grid xs={12} className='slide3gridone'>

                                <Grid xs={4}>
                                    <h2 className='question1 slide3'>{"Have you undergone any prior treatments for hair loss or scalp conditions?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "priortreatmentsforhairloss")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>

                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes, list treatments and approximate dates:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={priortreatmentsforhairloss['Please specify (if yes)']}
                                        disabled={priortreatmentsforhairloss['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "priortreatmentsforhairloss")}
                                        placeholder='If yes, list treatments and approximate dates:'
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>

                            <Grid xs={12} className='slide3gridtwo'>

                                <Grid xs={4}>
                                    <hr class="divider" />
                                    <h2 className='question1 slide3'>{"Have you used any hair growth products in the past?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "hairgrowthproductsinthepast")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>
                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder=' If yes, list the products and duration of use:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={hairgrowthproductsinthepast['Please specify (if yes)']}
                                        disabled={hairgrowthproductsinthepast['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "hairgrowthproductsinthepast")}
                                        placeholder=' If yes, list the products and duration of use:'
                                        variant="outlined"
                                    />
                                </Grid>
                                {/* <p className='ensuretext'>(Ensure this includes any over-the-counter or prescribed medications.)</p> */}

                            </Grid>


                            {/* <p>{props.item.description}</p> */}
                            {/* <Button className="CheckButton">
                    Check it out!
                </Button> */}
                        </CardContent>
                    </Card>
                </div>

                <div key={4}>

                    <Card className='subCardSection'>
                        <CardContent className="questionnairecard">
                            <Grid xs={12} className='slide3gridone'>

                                <Grid xs={4}>
                                    <h2 className='question1 slide3'>{"Are there any known contraindications regarding the prescribed compounded product?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "knowncontraindications")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>

                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes,please specify:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={knowncontraindications['Please specify (if yes)']}
                                        disabled={knowncontraindications['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "knowncontraindications")}
                                        placeholder='If yes,please specify:' variant="outlined" />
                                </Grid>
                            </Grid>

                            <Grid xs={12} className='slide3gridtwo'>

                                <Grid xs={4}>
                                    <hr class="divider" />
                                    <h2 className='question1 slide3'>{"Has the compounder been informed of any known risks related to your medication or health status?"}</h2>
                                </Grid>

                                <Grid xs={4}>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue='Yes'
                                        onChange={(e) => handleCheck(e, "compounderbeeninformed")}
                                    >
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="Yes" label="Yes" />
                                        <FormControlLabel control={<Radio icon={<CheckCircleOutlineIcon />}
                                            checkedIcon={<CheckCircleIcon />} sx={{
                                                '& .MuiSvgIcon-root': {
                                                    fontSize: 50,
                                                },
                                            }} />} value="No" label="No" />
                                    </RadioGroup>
                                </Grid>

                                <Grid xs={4}>
                                    {/* <TextField id="outlined-basic" label="" variant="outlined" placeholder='If yes, please describe:' /> */}
                                    <TextField
                                        id="outlined-multiline-static"
                                        //   label="Multiline"
                                        multiline
                                        rows={2}
                                        value={compounderbeeninformed['Please specify (if yes)']}
                                        disabled={compounderbeeninformed['Answer'] != "Yes"}
                                        onChange={(e) => handleChange(e, "compounderbeeninformed")}
                                        placeholder='If yes, please describe:' variant="outlined"
                                    />
                                </Grid>
                                <p className='ensuretext'>(Ensure this includes any over-the-counter or prescribed medications.)</p>

                            </Grid>


                            {/* <p>{props.item.description}</p> */}
                            {/* <Button className="CheckButton">
                    Check it out!
                </Button> */}
                        </CardContent>
                    </Card>
                </div>
            </Slider>

            {/* <BotComponent></BotComponent> */}

            {/* </Carousel> */}
            <Grid className="btnssection quesbtnsec">
                <Grid item xs={6}>
                    <div className="prevbtn" onClick={goPrev}>
                        <Button variant="contained">
                            <div className="prevbtntext">
                                <img src={imgurl.backarrow} alt="Backward arrows" />
                                <p> Previous </p>
                            </div>

                        </Button>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <div className="nextbtn">
                        <Button variant="contained" onClick={goNext}>
                            <div className="nextbtntext">
                                <p>{activeIndex == items-1?'Register':'Next'}  </p>
                                <img src={imgurl.arrows} alt="Forward arrows" />
                            </div>

                        </Button>
                    </div>
                </Grid>
            </Grid>
            <div className='shapeblue'>
                <img src={imgurl.shapeblue} alt="Blue shape" />
            </div>
            <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
        </div>
    );

}
export default Questionnaire;
